import { render, staticRenderFns } from "./PretClientForm.vue?vue&type=template&id=1bb5dce3&scoped=true&lang=true&"
import script from "./PretClientForm.vue?vue&type=script&lang=js&"
export * from "./PretClientForm.vue?vue&type=script&lang=js&"
import style0 from "./PretClientForm.vue?vue&type=style&index=0&id=1bb5dce3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5dce3",
  null
  
)

export default component.exports